/* External */
import { call, put } from 'redux-saga/effects';

/* Actions */
import { requestCreate, requestSuccess, requestFailure } from './actions';
import { resolveWhenConnectionAvailable } from '../../providers/ConnectionStatusProvider';

export function* requestSaga(serviceFunction, {
  payload,
  requestId,
}) {
  try {
    if (requestId) {
      yield put(requestCreate({ requestId }));
    }
    yield call(resolveWhenConnectionAvailable);
    const originalResponse = yield call(serviceFunction, payload);
    const { normalizedData } = originalResponse;
    if (requestId) {
      yield put(requestSuccess({ requestId, result: normalizedData?.result || undefined }));
    }
    return originalResponse;
  } catch (error) {
    console.error('requests>requestSaga', error);
    if (requestId) {
      yield put(requestFailure({ requestId }));
    }
    return undefined;
  }
}
